import { render, staticRenderFns } from "./shopify_webhook.vue?vue&type=template&id=935c811a&scoped=true&"
import script from "./shopify_webhook.vue?vue&type=script&lang=js&"
export * from "./shopify_webhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935c811a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('935c811a')) {
      api.createRecord('935c811a', component.options)
    } else {
      api.reload('935c811a', component.options)
    }
    module.hot.accept("./shopify_webhook.vue?vue&type=template&id=935c811a&scoped=true&", function () {
      api.rerender('935c811a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/organizations/advanced/shopify_webhook.vue"
export default component.exports